import type {
  SocialProofAward,
  SocialProofAwardInput,
  SocialProofClip,
  SocialProofClipInput,
  SocialProofLink,
  SocialProofQuote,
  SocialProofQuoteInput,
} from "./adtSocialProof.types";

import { brown } from "@/app/font";

export const SOCIAL_PROOF_LABELS = {
  playVideo: "Play video",
  pauseVideo: "Pause video",
  previousVideo: "Previous video",
  nextVideo: "Next video",
  previousTestimonial: "Previous testimonial",
  nextTestimonial: "Next testimonial",
  pauseTestimonials: "Pause testimonials",
  resumeTestimonials: "Play testimonials",
  videoUnavailable: "Video unavailable",
  seeMore: "See more",
} as const;

export const QUOTE_LINE_LIMIT = 6;

export const socialProofEyebrowClass = [
  brown.className,
  "text-[11px] font-bold tracking-[0.14em] text-primary uppercase sm:text-xs",
].join(" ");
export function socialProofLabel(
  value: string | null | undefined,
  fallback: string,
) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : fallback;
}

export function rotationSeconds(value: number | null | undefined) {
  if (!value || value < 3) return 8;
  return Math.min(120, Math.round(value));
}

export function stepIndex(index: number, count: number, forward: boolean) {
  if (forward) return (index + 1) % count;
  return (index - 1 + count) % count;
}

export function newTabProps(link?: SocialProofLink | null) {
  if (!link?.openInNewTab) return {};
  return { target: "_blank" as const, rel: "noopener noreferrer" };
}

export function isQuote(
  quote: SocialProofQuoteInput | null | undefined,
): quote is SocialProofQuote {
  return Boolean(quote?._key && quote.quote?.trim() && quote.name?.trim());
}

export function isAward(
  award: SocialProofAwardInput | null | undefined,
): award is SocialProofAward {
  return Boolean(award?._key && award.url);
}

export function toClip(clip: SocialProofClipInput): SocialProofClip {
  return {
    _key: clip._key ?? "",
    videoUrl: clip.video?.asset?.url ?? "",
    captionsUrl: clip.captions?.asset?.url || undefined,
  };
}
